export interface UnitOfMeasure {
  unitOfMeasureId: string;
  name: string;
}

export const defaultUnitOfMeasure: UnitOfMeasure = {
  unitOfMeasureId: null,
  name: null,
};
